var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AbaDadosCadastrais',{attrs:{"idFrom":_vm.$route.params.id != undefined ? +_vm.$route.params.id : 0,"isUpdate":_vm.isUpdate,"newToEdit":_vm.newToEdit,"abrev":_vm.abrev},on:{"voltar":function($event){return _vm.redirectToPage()},"saved":_vm.redirectToEdit}})
}
var staticRenderFns = []

export { render, staticRenderFns }